export const PERSONAL_DATA_STEP_ROUTE = 'dane-osobowe';
export const PERSONAL_DATA_STEP_PARAMETRIZED_ROUTE = ':id/dane-osobowe';
